import {
  CHANGE_ACCOUNT,
  IntegrationActionTypes,
  IntegrationState,
  LOAD_INTEGRATIONS,
  LOAD_INTEGRATIONS_SUCCESS,
  SAVE_INTEGRATION,
  SAVE_INTEGRATION_PENDING,
  SAVE_INTEGRATION_SUCCESS,
  CLEAR_MESSAGE,
} from "./types";

import { sortByField } from "../../lib/sort";

const initialSort = {
  field: "end",
  direction: false,
};

const initialState: IntegrationState = {
  loading: false,
  loadingIntegration: false,
  integrations: [],
  integrationsSortOptions: Object.assign({}, initialSort),
  adAccountLists: [],
  selectedAccount: "",
  redirectUser: false,
  message: "",
  facebookState: "", // NEW
} as any;

export function integrationReducer(
  state = initialState,
  action: IntegrationActionTypes
): any {
  switch (action.type) {
    case LOAD_INTEGRATIONS:
      return {
        ...state,
        integrations: [],
        loading: true,
        redirectUser: false,
      };

    case LOAD_INTEGRATIONS_SUCCESS:
      return {
        ...state,
        integrations: sortByField(
          state.integrationsSortOptions.field,
          state.integrationsSortOptions.direction,
          action.payload
        ),
        loading: false,
      };

    case SAVE_INTEGRATION:
      return {
        ...state,
        loading: true,
        redirectUser: false,
        message: "",
      };

    case SAVE_INTEGRATION_PENDING: {
      const accounts = action.payload && action.payload.accounts ? action.payload.accounts : [];
      const facebookState = action.payload && action.payload.facebookState ? action.payload.facebookState : "";
      const integrationId = action.payload && action.payload.integrationId ? action.payload.integrationId : null;

      return {
        ...state,
        adAccountLists: accounts,
        facebookState: facebookState,
        integrationId: integrationId,
        loading: false,
        redirectUser: false,
        message: "Pending...",
      };
    }

    case SAVE_INTEGRATION_SUCCESS: {
      const isAxiosResponse = action.payload && typeof (action.payload as any).status === "number";
      const status = isAxiosResponse ? (action.payload as any).status : 0;

      const success = isAxiosResponse && status >= 200 && status < 300;

      let message = "Integration failed";
      if (success) {
        message = "Success! Your account has been integrated.";
      } else {
        if (action.payload && (action.payload as any).message) message = (action.payload as any).message;
        else if (action.payload && (action.payload as any).data && (action.payload as any).data.error && (action.payload as any).data.error.message) {
          message = (action.payload as any).data.error.message;
        } else if (typeof action.payload === "string") {
          message = action.payload;
        } else {
          message = "Integration failed";
        }
      }

      return {
        ...state,
        redirectUser: success,
        loading: false,
        message: message,
        adAccountLists: success ? [] : state.adAccountLists,
        selectedAccount: success ? "" : state.selectedAccount,
      };
    }

    case CHANGE_ACCOUNT:
      return {
        ...state,
        selectedAccount: action.payload,
      };

    case CLEAR_MESSAGE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
